module.exports = __webpack_public_path__ + "static/media/box-usd.819c8199.svg";